<div *ngIf="status" class="outer-container">
    {{ status | spaceBetweenCaps }}
</div>
